import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=64d9fe10&scoped=true&"
import script from "./ExpansionPanel.vue?vue&type=script&lang=ts&"
export * from "./ExpansionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ExpansionPanel.vue?vue&type=style&index=1&id=64d9fe10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d9fe10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ec2-user/buildAgent/work/1ca6ccddf1d626f9/resources/vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VExpansionPanel,VExpansionPanelContent})
